import Translate from "utils/Translate";
import React, { useContext, useEffect, useState } from 'react'
import { upgColors } from 'styles/styles'
import { Select, MenuItem, FormControl, InputLabel, FormHelperText, Checkbox, ListItemText } from '@mui/material';
import './css/InputStyles.css'
import EyeNotVisible from '../icons/EyeNotVisible';
import EyeVisible from '../icons/EyeVisible';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Lock from 'components/icons/Lock';
import { padding } from '@mui/system';
import CaretDown from 'components/icons/CaretDown';
import { AppContext } from 'contexts/AppContext';
import {createUseStyles} from 'react-jss'

const jss = createUseStyles({
    labelStyle : {
        color: (styleGuide) => styleGuide.color6,
        "&.Mui-focused":{
            color: (styleGuide) => styleGuide.color6
        }
    }
})

const CustomSelect = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss(styleGuide)
    const defaultUnderlineColor = props.value ? styleGuide.color7 : styleGuide.color4
    const selectStyle = {
        backgroundColor: props.disabled ? styleGuide.color3 : `transparent`,
        "&:hover:before": {
            borderBottom : `2pt solid ${defaultUnderlineColor} !important`,
        },
        "&:hover:after": {
            borderBottom : `2pt solid ${styleGuide.color16} !important`,
        },
        "&:before": {
            borderBottom : `2pt solid ${defaultUnderlineColor} !important`,
        },
        "&:after": {
            borderBottom : `2pt solid ${styleGuide.color16} !important`,
        },
        "& :focus":{
            backgroundColor: 'white'
        }
    }

    const menuItemStyle = {
        ".MuiPaper-root": {
            borderRadius : `${styleGuide.selectDropdownBorderRadius}`
        },
        "ul":{
            borderRadius: 0,
            padding: '0 0 0 0'
        },
        "li:hover":{
            backgroundColor: `${styleGuide.color16} !important`,
            color: `${styleGuide.color1}`
        },
    }

    const labelStyle = {
        zIndex: props.disabled ? 1 : `inherit`,
        marginLeft: '15px',
        color: styleGuide.color6,
        "&.Mui-focused":{
            color: styleGuide.color7
        }
    }

    const helpTextStyle = {
        marginLeft: '15px',
        backgroundColor: 'white'
    }
    const helpText = props.helpObj && props.helpObj.helpText ? props.helpObj.helpText : ''
    const errorText = props.helpObj && props.helpObj.errorText ? props.helpObj.errorText : ''
    return (
        <div style={props.wrapperStyle}>
        <FormControl fullWidth variant="standard" error={props.error} hiddenLabel={false}>
            <InputLabel className={classes.labelStyle} style={{...labelStyle,  ...props.custlabelStyle}} id="select-label">{props.label}</InputLabel>
            <Select 
                variant='standard'
                labelId="select-label"
                style={props.style}
                value={props.value}
                className={props.className}
                onChange={props.onChange}
                sx={selectStyle}
                    MenuProps={
                        {
                            PaperProps: {
                                sx: {
                                    ...menuItemStyle,
                                       width: 250,
                                    }
                                },
                            variant: 'menu',
                        }}
            >   
                {props.emptyValue 
                    ? <MenuItem value={null}>{props.emptyValue.text || ''} </MenuItem> 
                    : null
                }

                {(props.options && props.options.length)
                    ? props.options.map(elem => {
                            return (
                                <MenuItem key={elem.value} value={elem.value} style={props.customMenuStyle}>
                                    { props.multiple 
                                        ?   <>
                                                <Checkbox checked={!!props.value && props.value.indexOf(elem.value) > -1} />
                                                <ListItemText primary={elem.label} />
                                            </>
                                        : elem.label}
                                </MenuItem>
                            )
                        })
                    : null 
                }
            </Select>
            {!props.disabled && <FormHelperText id="helper-text" style={helpTextStyle}>{ props.error ? errorText : helpText}</FormHelperText>}
        </FormControl>
        </div>
    )
}

export default CustomSelect;